import { memo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBolt} from "@fortawesome/free-solid-svg-icons";
import { useRecoilState } from "recoil";
import { Puller } from "./ConsoleUi.style";
import { openConsoleState } from "./ConsoleUi.state";
import { useUserQuery } from "../../monitor/User.state";

const ConsoleUiTrigger = () => {
    const { super_admin } = useUserQuery();
    const [open, setOpen] = useRecoilState(openConsoleState);
    const toggleDrawer = () => {
        setOpen(!open)
    }

    return super_admin
        ? (
            <Puller className={open ? 'is-opened' : ''} onClick={() => toggleDrawer()}>
                <FontAwesomeIcon icon={faBolt} />
            </Puller>
        )
        : null
}

export default memo(ConsoleUiTrigger);